import { logger } from '@platform/observability';
import type { z } from 'zod';
import { frontendConfigSchema } from './frontend-config.generated';

function loadRuntimeConfig(): unknown {
  const el = document.getElementById('frontend-config');
  if (!el?.textContent) {
    return {};
  }
  try {
    return JSON.parse(el.textContent);
  } catch {
    logger.warn('[env] Failed to parse frontend-config script tag');
    return {};
  }
}

export type RuntimeEnv = z.infer<typeof frontendConfigSchema>;

export function parseRuntimeEnv(): RuntimeEnv {
  return frontendConfigSchema.parse(loadRuntimeConfig());
}

export const env: RuntimeEnv = parseRuntimeEnv();
